module.exports = __webpack_public_path__ + "fonts/AvenirSemiBold.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AvenirSemiBold.ttf
// module id = 478
// module chunks = 12